<template>
  <div class="custom-amount-form">
    <Header />
    <section class="main">
      <AmountSelector />
      <ReceiptSend />
      <PayMethods />
      <Footer />
    </section>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import AmountSelector from "@/components/AmountSelector.vue";
import ReceiptSend from "@/components/ReceiptSend.vue";
import PayMethods from "@/components/PayMethodsWithButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    AmountSelector,
    ReceiptSend,
    PayMethods,
    Footer,
  },
};
</script>
